module.exports = __webpack_public_path__ + "static/img/ai_text.aeda169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai_text.png
// module id = 8YFV
// module chunks = 0